module.exports = __webpack_public_path__ + "static/media/help-icon.14e224ab.png";